import { EntityStatuses } from '.';
import { Option } from './option';

type stnb = string | number;
export type ArrayToType<T extends readonly stnb[]> = T[number];

export const QuestionTypesArray = ['text', 'checkbox', 'date', 'email', 'options'] as const;
export const LayoutTypesArray = ['grid', 'icons-grid', 'pinterest'] as const;
export const OptionsTypesArray = [
  'simple',
  'simple-bordered',
  'images',
  'palettes',
  'icons',
  'cards',
  'colors',
] as const;
export const GridBreakpointsArray = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
export const justifyContentArray = ['start', 'end', 'between', 'center', 'around'] as const;

export type QuestionTypesType = ArrayToType<typeof QuestionTypesArray>;
export type LayoutsTypesType = ArrayToType<typeof LayoutTypesArray>;
export type OptionsTypesType = ArrayToType<typeof OptionsTypesArray>;
export type GridBreakpointsArrayType = ArrayToType<typeof GridBreakpointsArray>;
export type justifyContentArrayType = ArrayToType<typeof justifyContentArray>;

export const justifyContent = {
  ['start']: {
    text: 'Pack flex items from the start (flex-start)',
  },
  ['end']: {
    text: 'Pack flex items from the end (flex-end)',
  },
  ['between']: {
    text: 'The first item is flush with the start, the last is flush with the end (space-between)',
  },
  ['center']: {
    text: 'Pack items around the center (center)',
  },
  ['around']: {
    text: 'Items have a half-size space on either end (space-around)',
  },
};

export interface QuestionMetadata {
  grid: {
    padding: number;
    items: { [key in GridBreakpointsArrayType]?: number };
    breakpoints: { [key in GridBreakpointsArrayType]?: number };
    container: {
      show: boolean;
      width: { [key in GridBreakpointsArrayType]?: number };
    };
    row: {
      justifyContent: justifyContentArrayType;
    };
  };
}

export interface Question {
  id?: string;
  name: string;
  text: string;
  question?: string;
  footerMessage?: string;
  placeholderText?: string;
  minAnswers?: number;
  maxAnswers?: number;
  required: boolean;
  type: QuestionTypesType;
  options?: Option[];
  layout: LayoutsTypesType;
  optionsType: OptionsTypesType;
  showLabels: boolean;
  status: EntityStatuses;
  metadata?: QuestionMetadata;
  order: number | null;
}
